const POLYFILL_INSTALLED_KEY = '__NYL_CRYPTO_RANDOM_UUID_POLYFILL__';

function formatUuidV4(bytes) {
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function createRandomUuidFromGetRandomValues(getRandomValues) {
  const bytes = new Uint8Array(16);
  getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  return formatUuidV4(bytes);
}

function createRandomUuidFromMathRandom() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const randomNibble = Math.floor(Math.random() * 16);
    if (character === 'x') {
      return randomNibble.toString(16);
    }
    return ((randomNibble & 0x3) | 0x8).toString(16);
  });
}

export function createRandomUuid(cryptoLike = {}) {
  if (typeof cryptoLike.getRandomValues === 'function') {
    return createRandomUuidFromGetRandomValues(
      (array) => cryptoLike.getRandomValues(array),
    );
  }

  return createRandomUuidFromMathRandom();
}

/**
 * Adobe DCS registration tags call window.crypto.randomUUID on page load.
 * Older Safari/iOS builds expose crypto.getRandomValues but not randomUUID.
 */
export function installCryptoRandomUuidPolyfill(globalObject = typeof window !== 'undefined' ? window : undefined) {
  if (!globalObject || globalObject[POLYFILL_INSTALLED_KEY]) {
    return;
  }

  try {
    const cryptoObject = globalObject.crypto || globalObject.msCrypto;
    if (!cryptoObject) {
      return;
    }

    if (typeof cryptoObject.randomUUID === 'function') {
      globalObject[POLYFILL_INSTALLED_KEY] = true;
      return;
    }

    cryptoObject.randomUUID = () => createRandomUuid(cryptoObject);

    if (!globalObject.crypto) {
      globalObject.crypto = cryptoObject;
    }

    globalObject[POLYFILL_INSTALLED_KEY] = true;
  } catch (e) {
    // Some embedded browsers block redefining crypto APIs.
  }
}
